<div *ngIf="typeData && typeData.length > 0"
  style="display: block">
  <canvas baseChart
    height="180"
    [data]="typeData"
    [labels]="typeLabels"
    [legend]="false"
    [options]="barOptions"
    [colors]="barColors"
    chartType="bar"></canvas>
</div>